// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"353":"3ec9d954","462":"f8252945","782":"61c1803c","976":"282e0636"}[chunkId] + ".css";
};